class TeamMember {
    userId = "";
    from = null;
    to = null;
    firstName = "";
    lastName = "";
    constructor(json) {
        if (json !== null) {
            try {
                this.userId = json.userId || '';
                this.firstName = json.firstName || '';
                this.from = this.convertToDate(json.from) || null;
                this.to = this.convertToDate(json.to) || null;
                this.lastName = json.lastName || '';
            }
            catch (err) {
                window.errorHandler.logError(err, 'Types/TeamMember.ts -> constructor');
            }
        }
    }
    convertToDate(date) {
        if (date !== null) {
            return window.dateHandler.convertToUTCTime(date);
        }
        else {
            return null;
        }
    }
}
export default TeamMember;
